export default function stopMapEventPropagation(event) {
  event.stopPropagation()
}

export function hasHarvestOptions(harvestOptions) {
  return Object.keys(harvestOptions).length > 0
}
